import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const BoxClassName = `${CLASS_NAME_PREFIX}-box`;
export const PropsToBeCssPrefixPrepended = [
  "m",
  "margin",
  "mt",
  "marginTop",
  "mr",
  "marginRight",
  "mb",
  "marginBottom",
  "ml",
  "marginLeft",
  "mx",
  "my",
  "p",
  "padding",
  "pt",
  "paddingTop",
  "pr",
  "paddingRight",
  "pb",
  "paddingBottom",
  "pl",
  "paddingLeft",
  "px",
  "py",
  "gap",
];
